import { environment } from 'environments/environment';
import { OptionsInput } from 'fullcalendar/src/types/input-types';

export const Config = {
	language: 'it',
	baseURL: environment.baseURL || 'https://team14-next-api.herokuapp.com/api',
	webSocketURI: environment.webSocketURI || 'wss://team14-next-api.herokuapp.com/api',
	baseURLScT: environment.baseURLScT || '<missing-sct-url>',
	oauthNode: environment.oauthNode || '<missing-oauth-node>',
	defaultCalendarOptions: <OptionsInput>{
		aspectRatio: 16 / 9,
		locale: 'it',
		header: {
			left: 'prev,next,today',
			center: 'title',
			right: 'listWeek,agendaDay,agendaWeek,month'
		},
		height: () => $(window).height() - 130,
		firstDay: 1,
		fixedWeekCount: false,
		eventLimit: true,
		editable: true,
		navLinks: true, // can click day/week names to navigate views
		selectHelper: true,
		nowIndicator: true
	},
	defaultQtip2Options: <QTip2.QTipOptions>{
		style: {
			classes: 'qtip-bootstrap'
		},
		position: {
			my: 'top center',
			at: 'bottom center'
		},
		hide: {
			fixed: true
		}
	},
	defaultMobileQtip2Options: <QTip2.QTipOptions>{
		style: {
			classes: 'qtip-bootstrap'
		},
		position: {
			my: 'top center',
			at: 'bottom center'
		},
		show: 'click',
		hide: {
			fixed: true
		}
	},
	doubleClickTime: 250,
	searchDebounceTime: 250,
	codiceFiscaleDebounceTime: 250,
	searchMaxResultNumber: 20,
	contatti: {
		pageSize: 6
	},
	pazienti: {
		refreshInterval: 30 * 60 * 1000 // ms
	},
	fuse: {
		shouldSort: true,
		// threshold: 0.6,
		threshold: 0.1,
		location: 0,
		distance: 100,
		maxPatternLength: 32
	},
	cookiePolicyURL: "http://www.savestudi.it/cookies.html",
	copyrightBaseYear: 2018
};



// WEBPACK FOOTER //
// ./src/app/config.const.ts